// extracted by mini-css-extract-plugin
export default {"cardContent":"HighLevelInfoFormContent_cardContent__OzDf5","diluentMaterial":"HighLevelInfoFormContent_diluentMaterial__sHNzt"};